import { render, staticRenderFns } from "./PostListItem.vue?vue&type=template&id=b29be7fe&scoped=true&"
import script from "./PostListItem.vue?vue&type=script&lang=js&"
export * from "./PostListItem.vue?vue&type=script&lang=js&"
import style0 from "./PostListItem.scss?vue&type=style&index=0&id=b29be7fe&lang=scss&scoped=true&"
import style1 from "./PostListItem.vue?vue&type=style&index=1&id=b29be7fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29be7fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VChip,VDialog,VIcon})
